import _ from 'lodash';
import React from 'react';

import DateRangePicker from 'components/DateRangePicker';

import ToggleSelectFilter from 'components/Filters/ToggleSelectFilter';

import './styles.css';

const BottomLeftFixedCustomOverlay = ({
  children,
  onBlur,
  onFocus,
  tabIndex,
  input
}: any) => {
  // Custom Overlay will be fixed to bottom right from input

  const position = input.parentElement.getBoundingClientRect();

  return (
    <div
      className="BottomLeftFixedCustomOverlay"
      onBlur={onBlur}
      onFocus={onFocus}
      tabIndex={tabIndex}
      style={{right: 20, top: position.top + position.height}}>
      <div className="OverlayWrapper colab-small-border-radius">{children}</div>
    </div>
  );
};

interface OutOfOrderReasonWithDateRangeFilterProps {
  outOfOrderReasons: Array<string>;
  data: Array<{label: string; value: string}>;
  outOfOrderStartDate: string | null;
  outOfOrderEndDate: string | null;
  setFilter: any;
}

class OutOfOrderReasonWithDateRangeFilter extends React.Component<
  OutOfOrderReasonWithDateRangeFilterProps
> {
  onOutOfOrderReasonChange = (field, value) => {
    if (field == 'purpose') {
      const withoutFetching =
        !this.props.outOfOrderStartDate || !this.props.outOfOrderEndDate;

      this.props.setFilter('outOfOrderReasons', value, withoutFetching);
    } else if (field == 'startDate') {
      const withoutFetching =
        this.props.outOfOrderReasons.length == 0 ||
        !this.props.outOfOrderEndDate;

      this.props.setFilter('outOfOrderStartDate', value, withoutFetching);
    } else if (field == 'endDate') {
      const withoutFetching =
        !this.props.outOfOrderStartDate ||
        this.props.outOfOrderReasons.length == 0;

      this.props.setFilter('outOfOrderEndDate', value, withoutFetching);
    }
  };
  render() {
    return (
      <div className="OutOfOrderReasonWithDateRangeFilter">
        <ToggleSelectFilter
          label="Out of order reasons"
          data={this.props.data}
          value={this.props.outOfOrderReasons}
          onChange={value => this.onOutOfOrderReasonChange('purpose', value)}
        />
        {!_.isEmpty(this.props.outOfOrderReasons) && (
          <DateRangePicker
            className="colab-small-border-radius"
            overlayComponent={BottomLeftFixedCustomOverlay}
            start={this.props.outOfOrderStartDate}
            end={this.props.outOfOrderEndDate}
            handleChange={this.onOutOfOrderReasonChange}
          />
        )}
      </div>
    );
  }
}

export default OutOfOrderReasonWithDateRangeFilter;
